/* LucidChat article navigation and local-only reading aid. */
(function () {
    const content = document.querySelector('[data-lc-article-content]');
    const toc = document.querySelector('[data-lc-toc]');
    const progress = document.querySelector('[data-lc-reading-progress]');
    const header = document.querySelector('#gh-navigation');

    if (content && toc) {
        const headings = Array.from(content.querySelectorAll('h2'));

        headings.forEach(function (heading, index) {
            if (!heading.id) {
                const slug = heading.textContent
                    .toLowerCase()
                    .trim()
                    .replace(/[^a-z0-9\s-]/g, '')
                    .replace(/\s+/g, '-')
                    .replace(/-+/g, '-');
                const base = slug || `section-${index + 1}`;
                let id = base, suffix = 2;
                while (document.getElementById(id)) id = `${base}-${suffix++}`;
                heading.id = id;
            }

            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent;
            link.dataset.tocTarget = heading.id;
            link.addEventListener('click', function () {
                heading.setAttribute('tabindex', '-1');
                heading.focus({preventScroll: true});
                if (!window.matchMedia('(min-width: 1101px)').matches) toc.closest('details').open = false;
            });
            item.appendChild(link);
            toc.appendChild(item);
        });

        const details = toc.closest('details');
        const desktop = window.matchMedia('(min-width: 1101px)');
        const setMode = function () { details.open = desktop.matches; };
        desktop.addEventListener('change', setMode);
        setMode();
        if (!headings.length) details.hidden = true;

        // Geometry is article-scoped, not document/footer length. One passive scroll listener.
        const updateReading = function () {
            const headerHeight = header ? header.getBoundingClientRect().height : 0;
            document.documentElement.style.setProperty('--lc-reading-header', `${headerHeight}px`);
            const rect = content.getBoundingClientRect();
            const available = Math.max(1, window.innerHeight - headerHeight - 3);
            const distance = Math.max(1, rect.height - available);
            const fraction = rect.top >= headerHeight + 3 ? 0
                : rect.bottom <= window.innerHeight ? 1
                : Math.min(1, Math.max(0, (headerHeight + 3 - rect.top) / distance));
            if (progress) {
                progress.setAttribute('aria-valuenow', String(Math.round(fraction * 100)));
                progress.querySelector('span').style.transform = `scaleX(${fraction})`;
            }
            let current = headings[0];
            headings.forEach(function (heading) {
                if (heading.getBoundingClientRect().top <= headerHeight + 28) current = heading;
            });
            toc.querySelectorAll('a').forEach(function (link) {
                const active = current && link.dataset.tocTarget === current.id;
                link.classList.toggle('is-active', active);
                if (active) link.setAttribute('aria-current', 'location');
                else link.removeAttribute('aria-current');
            });
        };
        let scheduled = false;
        const scheduleReading = function () {
            if (scheduled) return;
            scheduled = true;
            window.requestAnimationFrame(function () { scheduled = false; updateReading(); });
        };
        window.addEventListener('scroll', scheduleReading, {passive: true});
        window.addEventListener('resize', scheduleReading);
        window.addEventListener('pageshow', scheduleReading);
        if ('ResizeObserver' in window) {
            const observer = new ResizeObserver(scheduleReading);
            observer.observe(content);
            if (header) observer.observe(header);
        }
        updateReading();
    }

    const checklist = document.querySelector('[data-gate-checklist]');
    if (checklist) {
        const boxes = Array.from(checklist.querySelectorAll('input[type="checkbox"]'));
        const count = checklist.querySelector('[data-gate-count]');
        const progress = checklist.querySelector('[data-gate-progress]');

        const update = function () {
            const completed = boxes.filter(function (box) { return box.checked; }).length;
            count.textContent = `${completed} of ${boxes.length} explored`;
            progress.style.width = `${(completed / boxes.length) * 100}%`;
        };

        boxes.forEach(function (box) {
            box.addEventListener('change', update);
        });
        update();
    }
})();
